module.exports = "<!DOCTYPE html><form id=\"themeEditForm\" #themeEditForm><div class=\"row\"><div class=\"col-xs-12\"><label for=\"id\">Nombre:</label><input id=\"id\" name=\"id\"></div></div><div class=\"row\"><div class=\"col-xs-12\"><label for=\"base\">Tema Base</label><select id=\"base\" name=\"base\"></select></div></div><div class=\"row\"><div class=\"col-xs-12\"><span>Layouts</span></div></div></form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/themes/theme-form.component.pug
// module id = 1688
// module chunks = 0